import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import setup from './../images/setup.png';
import parallax from './../images/parallax.png';
import staging from './../images/staging.png';
import reflection from './../images/reflection.png';

import Utils from '../../common/Utils.jsx';
import TextFormat from '../../common/TextFormat.jsx';

const PARAGRAPH_SIZE = 5;
const MAX_STATEMENTS = 65;

const PageContent = styled.div`
    margin-top: 1.25rem;
`;

const SidebarWrapper = styled.div`
    padding: 0.75rem;
    margin: 0 2rem 1rem;
    border: 0.1rem solid #cccccc;
    border-radius: 0.25rem;
`;

const SidebarImage = styled.img`
    width: 95%;
`;

const SidebarText = styled.div`
    font-style: italic;    
    color: #888888;
    font-size: 0.85rem;
`;

const NarrativeBlock = styled.div`
    color: #888888;
    font-size: 1rem;
    text-align: justify;
    margin: 1rem 0;
    padding: 0 2rem 0 0;
    vertical-align: top;
`;

export class FeedbackProjectionExtra extends Component {

    static propTypes = {
        sections: PropTypes.object.isRequired,
        explainers: PropTypes.object.isRequired,
        on_reference_click: PropTypes.func.isRequired,
        references: PropTypes.object.isRequired
    }

    render() {
        const {explainers, sections, on_reference_click, references} = this.props;

        let narrative_blocks = []
        const section_keys = Object.keys(sections);
        section_keys.forEach(key => {
            const section_items = sections[key].items;
            const section_item_keys = Object.keys(section_items);
            section_item_keys.forEach(section_key => {
                const comments = section_items[section_key].items.comments
                if (!comments) {
                    return;
                }
                if (!comments.items) {
                    return;
                }
                const comments_keys = Object.keys(comments.items);
                comments_keys.forEach((comment_key, comment_index) => {
                    const comment = comments.items[comment_key];
                    if (comment) {
                        narrative_blocks.push(comment);
                    }
                })
            });
        });
        const all_text = Utils.shuffle(narrative_blocks).slice(0, MAX_STATEMENTS).map(n => n.value);

        const explainer_data = [
            {name: "setup", image: setup, width_rem: 25, text: []},
            {name: "staging", image: staging, width_rem: 25, text: []},
            {name: "parallax", image: parallax, width_rem: 25, text: []},
            {name: "reflection", image: reflection, width_rem: 20, text: []},
        ];
        all_text.forEach((text, index) => {
            const explainer_index = index % explainer_data.length;
            const exp_data = explainer_data[explainer_index];
            exp_data.text.push(text);
        });

        const all_blocks = [];
        Utils.shuffle(explainer_data).forEach((exp_data, index) => {
            const floating = index % 2 ? 'right' : 'left';
            const margin_left = index % 2 ? '1.25rem' : '0';
            const margin_right = index % 2 ? '2rem' : '1.25rem';
            const sidebar_style = {
                float: floating,
                marginLeft: margin_left,
                marginRight: margin_right,
                width: exp_data.width_rem + "rem"
            };
            all_blocks.push(<SidebarWrapper key={"wrapper_" + index} style={sidebar_style}>
                <SidebarImage src={exp_data.image}/>
                <SidebarText>
                    <TextFormat
                        text={explainers[exp_data.name].value}
                        is_first={false} of_many={false}
                        on_reference_click={on_reference_click}
                    />
                </SidebarText>
            </SidebarWrapper>)

            const split_parts = 1 + Math.floor(exp_data.text.length / PARAGRAPH_SIZE);
            const all_parts = [];
            for (let part = 0; part < split_parts; part++) {
                all_parts.push([]);
            }
            exp_data.text.forEach(text => {
                const part_index = Math.floor(Math.random() * split_parts);
                all_parts[part_index].push(text);
            });
            all_parts.forEach(p => {
                const text_blocks = p.map((t, i) => {
                    return <TextFormat
                        key={i} text={t} is_first={!i} of_many={true}
                        references={references} on_reference_click={on_reference_click}
                    />
                });
                all_blocks.push(<NarrativeBlock key={"block_" + all_blocks.length}>{text_blocks}</NarrativeBlock>)
            })
        });

        return <PageContent>
            {all_blocks}
        </PageContent>
    }
}

export default FeedbackProjectionExtra;
